// app/components/form-sections/ClosingSection.jsx
"use client";
import Field from "../ui/Field";
import Select from "../ui/Select";

export default function ClosingSection({ form, setField }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 mt-6">
      <Field label="Recommendation Strength (1–5)">
        <div className="flex items-center gap-3">
          <input
            type="range"
            min={1}
            max={5}
            step={1}
            value={form.strength_rating}
            onChange={setField("strength_rating")}
            className="w-full accent-teal-600"
          />
          <span className="inline-flex min-w-10 justify-center rounded-md bg-gradient-to-r from-teal-500/10 to-orange-500/10 px-2 py-1 text-sm font-semibold text-gray-700 border border-gray-200">
            {form.strength_rating}
          </span>
        </div>
      </Field> 
{/* 
      <Field label="Recommendation Strength (wording)">
        <Select value={form.rec_strength} onChange={setField("rec_strength")}>
          <option value="strongly">strongly</option>
          <option value="enthusiastically">enthusiastically</option>
          <option value="wholeheartedly">wholeheartedly</option>
          <option value="without reservation">without reservation</option>
        </Select>
      </Field>  */}

      <Field label="Signature">
        <input
          placeholder="e.g., Casey Rivera"
          className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
          value={form.signature}
          onChange={setField("signature")}
        />
      </Field>
    </div>
  );
}
